/** 任务列表与调用日志（/console/tasks）、任务详情（/console/tasks/:id）。 */
const messages = {
  'list.title': '任务与调用日志',
  'list.description': '任务状态与费用，以及每一次 API 调用的记录。进行中的任务会自动刷新。',
  'list.submit': '提交任务',
  'tab.tasks': '任务',
  'tab.logs': '调用日志',

  'filter.from': '开始日期',
  'filter.to': '结束日期',
  'filter.all': '全部',
  'filter.status': '状态',
  'filter.model': '模型',
  'filter.key': 'API Key',
  'filter.keyOption': '{name}（{display}）',
  'filter.clear': '清除筛选',
  'filter.result': '结果',
  'filter.ok': '成功（< 400）',
  'filter.error': '出错（≥ 400）',

  'export.button': '导出 CSV',
  'export.title': '导出 {from} 至 {to} 的任务',
  'export.range':
    '导出范围 <d>{from}</d> 至 <d>{to}</d>（{mode, select, picked {按所选日期} other {默认近 30 天}}）',

  'meta.loading': '正在加载…',
  'meta.loaded': '第 {page} 页 · 本页 {n} 个任务',
  'meta.polling': '有任务在进行中，每 5 秒自动刷新',

  'col.taskId': '任务 ID',
  'col.status': '状态',
  'col.modelParams': '模型与参数',
  'col.key': 'Key',
  'col.created': '创建时间',
  'col.elapsed': '耗时',
  'col.cost': '费用',
  'col.params': '参数',
  'col.createdShort': '创建',
  'col.time': '时间',
  'col.request': '请求',
  'col.errorCode': '错误码',
  'col.task': '任务',
  'col.requestId': '请求 ID',

  'source.playground': '控制台试用',
  'source.console': '控制台',
  'log.billable': '计费',

  'tasks.loadFailed': '任务列表加载失败',
  'tasks.emptyFiltered': '没有符合条件的任务，调整筛选条件后再试。',
  'tasks.empty': '还没有任务。用 API 提交，或先在控制台试用生成一个视频。',
  'tasks.quickstart': '快速开始',
  'tasks.tryPlayground': '去控制台试用',

  'lifecycle.title': '一个任务会经过的状态',
  'lifecycle.description': '状态列显示的就是这些。进行中的任务每 5 秒自动刷新，也可以等 Webhook 通知。',
  'lifecycle.queued': '已受理并冻结额度，等待处理线路',
  'lifecycle.preparing': '把输入素材准备到这条线路',
  'lifecycle.running': '上游正在生成视频',
  'lifecycle.recovering': '当前线路出错，换到另一条继续，任务 ID 不变',
  'lifecycle.finalizing': '按实际输出结算，差额退回可用额度',
  'lifecycle.succeeded': '可以播放和下载；失败时冻结额度全部退回',

  'logs.refresh': '刷新',
  'logs.meta': '记录所有 /v1 与控制台试用请求。排查问题时，把请求 ID 发给运营即可定位。',
  'logs.loadFailed': '调用日志加载失败',
  'logs.empty': '暂无调用记录。用 API Key 调用接口后，这里会显示每次请求的状态、耗时与请求 ID。',

  'detail.title': '任务详情',
  'detail.document': '任务 {id} · aitoken.tools',
  'detail.back': '任务与调用日志',
  'detail.notFound': '找不到这个任务：它不存在，或不属于当前账号。',
  'detail.viewAll': '查看全部任务',
  'detail.loadFailed': '任务加载失败',
  'detail.inProgress': '任务进行中，页面每 5 秒自动刷新。可以离开此页，稍后在任务列表查看结果。',
  'detail.elapsed': '耗时',
  'detail.elapsedSoFar': '已用时',
  'detail.cost': '费用 · {label}',
  'detail.createdAt': '创建于',
  'detail.finishedAt': '结束于',
  'detail.deadline': '处理时限',
  'detail.source': '来源 · 请求 ID',
  'detail.keySource': '{name}（{display}）',

  'timeline.title': '处理时间线',
  'timeline.total': '总耗时',
  'timeline.soFar': '已用时',
  'timeline.switched': '期间平台切换过处理线路，任务 ID 未变',
  'timeline.lane': '处理',
  'timeline.laneSub': '同一任务 ID',
  'timeline.settled': '结算 {amount}（仅一次）',
  'timeline.failedCharged': '失败 · 已按规则结算',
  'timeline.failedRefunded': '失败 · 冻结额度已全部退回',
  'timeline.steps': '状态变化',
  'timeline.recoveringNote': '当前线路异常，在另一条线路继续处理',

  'result.title': '生成结果',
  'result.expired': '结果文件已超过保留期，平台已清理这个视频。今后请在保留期内转存到你自己的存储。',
  'result.preview': '结果预览，结算完成后状态会变为成功。',
  'result.ready': '可直接播放或下载。',
  'result.refresh': '获取新地址',
  'result.download': '下载视频',
  'result.urlExpired': '播放地址已过期，点击“获取新地址”即可继续播放。',
  'result.videoAria': '生成的视频',
  'result.prompt': '提示词：',
  'result.urlValid': '播放与下载地址有效至 <d>{at}</d>（{relative}），过期后重新查询任务即可获得新地址。',
  'result.retained': '文件保留至 <d>{at}</d>，之后将被清理，请及时转存。',
  'result.lastFrame': '查看尾帧图片',
  'result.upstream': '上游原始视频链接',
  'result.upstreamValid': '上游原始链接有效至 {at}（{relative}），失效后请使用上方平台地址。',

  'failure.title': '任务失败',
  'failure.suggestion': '建议：{text}',
  'failure.contact': '联系运营时请提供请求 ID',

  'billing.title': '费用',
  'billing.reserve': '受理时冻结',
  'billing.reserveHint': '按参数上界冻结，不会超过它',
  'billing.settle': '按用量结算',
  'billing.settleHintWaived': '平台原因失败，费用全免',
  'billing.settleHint': '实际扣除的金额，只结算一次',
  'billing.release': '释放差额',
  'billing.releaseHint': '退回可用额度',
  'billing.pending': '待定',
  'billing.ledger': '查看额度流水',

  'params.title': '请求参数',
  'params.noPrompt': '未填写提示词',
  'params.model': '模型',
  'params.modelUsed': '实际模型',
  'params.fallbackNote': '跨模型兜底：主模型暂无可用线路，已按你的设置改用此模型，并按此模型计费',
  'params.modelVersion': '模型版本',
  'params.resolution': '分辨率',
  'params.ratio': '比例',
  'params.duration': '时长',
  'params.auto': '自动',
  'params.seconds': '{n} 秒',
  'params.inputs': '输入素材',
  'params.noInputs': '无（文生视频）',
};

export default messages;
